/**
 * Juwelier Reichart · Bewegung für die ganze Seite.
 * 1. Einblenden: Elemente mit [data-jr-zeigen] (und eine Auswahl typischer Bausteine, die hier automatisch markiert werden)
 *    erscheinen beim Hereinscrollen, Geschwister gestaffelt. Ohne JavaScript oder bei reduzierter Bewegung bleibt alles sichtbar.
 * 2. Lichtschimmer: Über [data-jr-licht] folgt ein heller, goldener Lichtkegel dem Mauszeiger (nur bei Maus/Trackpad).
 */

const ruhig = matchMedia('(prefers-reduced-motion: reduce)').matches;
const maus = matchMedia('(hover: hover) and (pointer: fine)').matches;

// Bausteine, die ohne eigenes Markup mitanimiert werden
const AUTO_ZEIGEN = [
  '.jr .jr-oberzeile',
  '.jr .jr-titel',
  '.jr .jr-text',
  '.jr .jr-knoepfe',
  '.jr-welten__kachel',
  '.jr-hero__fakt',
  '.jr-marke__bild, .jr-marke__text > *',
  '.jr-geschichte__punkt',
  'product-card',
];
const AUTO_LICHT = ['.jr-welten__kachel', 'product-card .card-gallery', '.jr-hero__flaeche'];

function markieren(wurzel = document) {
  for (const sel of AUTO_ZEIGEN) {
    wurzel.querySelectorAll(sel).forEach((el) => {
      if (!el.hasAttribute('data-jr-zeigen')) el.setAttribute('data-jr-zeigen', '');
    });
  }
  if (maus) {
    for (const sel of AUTO_LICHT) {
      wurzel.querySelectorAll(sel).forEach((el) => el.setAttribute('data-jr-licht', ''));
    }
  }
}

function einblenden() {
  const elemente = [...document.querySelectorAll('[data-jr-zeigen]:not(.is-gezeigt)')];
  if (ruhig || !('IntersectionObserver' in window)) {
    elemente.forEach((el) => el.classList.add('is-gezeigt'));
    return;
  }
  document.documentElement.classList.add('jr-bewegung');
  const beobachter = new IntersectionObserver(
    (eintraege) => {
      for (const e of eintraege) {
        if (!e.isIntersecting) continue;
        const el = /** @type {HTMLElement} */ (e.target);
        // Staffelung unter Geschwistern, die gleichzeitig sichtbar werden
        const geschwister = el.parentElement
          ? [...el.parentElement.children].filter((k) => k.hasAttribute('data-jr-zeigen'))
          : [];
        const i = Math.max(0, geschwister.indexOf(el));
        el.style.setProperty('--jr-verzug', `${Math.min(i, 6) * 90}ms`);
        el.classList.add('is-gezeigt');
        beobachter.unobserve(el);
      }
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
  );
  elemente.forEach((el) => beobachter.observe(el));
}

function licht() {
  if (!maus || ruhig) return;
  document.addEventListener(
    'pointermove',
    (e) => {
      const ziel = /** @type {HTMLElement | null} */ (
        e.target instanceof Element ? e.target.closest('[data-jr-licht]') : null
      );
      if (!ziel) return;
      const r = ziel.getBoundingClientRect();
      ziel.style.setProperty('--jr-lx', `${(((e.clientX - r.left) / r.width) * 100).toFixed(1)}%`);
      ziel.style.setProperty('--jr-ly', `${(((e.clientY - r.top) / r.height) * 100).toFixed(1)}%`);
    },
    { passive: true }
  );
}

function start() {
  markieren();
  einblenden();
  licht();
  // Nachgeladene Abschnitte (Theme-Editor, Filter, Warenkorb) ebenfalls erfassen
  document.addEventListener('shopify:section:load', () => {
    markieren();
    einblenden();
  });
  let geplant = 0;
  new MutationObserver(() => {
    if (geplant) return;
    geplant = requestAnimationFrame(() => {
      geplant = 0;
      markieren();
      einblenden();
    });
  }).observe(document.querySelector('main') || document.body, { childList: true, subtree: true });
}

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
else start();
